// components/ReportCard.jsx
import React from "react";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const ReportCard = ({
  item,
  roles,
  setEditMode,
  setSelectedReport,
  setModal,
  handleDeleteReport,
  updateBookmarkStatus,
  onClick,
  smallView = false,
  className='' // 👈 for sidebar compact layout
}) => {
  return (
     <div
      title={item.title}
      onClick={() => onClick(item)}
    className={`relative py-2 ml-4 px-1 text-[13px] hover:scale-105 hover:z-10 rounded-lg flex justify-between items-center ${className}`}
    >
      {/* Title */}
      <div className="flex justify-between mb-1">
 <h3
        className="break-words text-black-400 max-w-[150px] min-w-[150px] text-wrap font-semibold"
      >
        {item.title} 
      </h3>
       {(roles?.role_name?.includes("Admin") ||
        roles?.role_name?.includes("Editor")) && (
        <>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setEditMode(true);
              setSelectedReport(item);
              setModal(true);
            }}
          >
            <FaEdit className="text-red-600" />

          </button>

          <button
          className="px-1"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteReport(item._id, item?.report?.id);
            }}
          >
            <MdDelete className="text-red-600" />

          </button>
        </>
      )}
      </div>
    </div>
  );
};

export default ReportCard;
